export default __webpack_public_path__ + "static/media/anoop_Ramachandra-comportment.90ad3554.png";